import {deepMergeAll} from 'tizra'
import * as A from '../admin'

export interface Config {
  VERSION: 1
  justification: 'left' | 'center' | 'right'
  position: 'left' | 'center' | 'right'
  heading: string
  prop: string
}

export const defaultConfig: Config = {
  VERSION: 1,
  justification: 'left',
  position: 'left',
  heading: '',
  prop: '',
}

export const migrate: A.Migrate<Config, any> = ({config}) => {
  if (config && !config.VERSION && config.alignment) {
    config.justification ||= config.alignment
    config.position ||= config.alignment
    delete config.alignment
    config.VERSION = 1
  }
  return deepMergeAll(defaultConfig, config)
}

export const AbstractAdmin: A.Admin<Config> = () => {
  const propOptions = A.usePropOptions({
    spec: 'sub-prop-defs',
    types: ['html', 'keyword', 'markdown', 'string', 'text'],
  })

  return (
    <>
      <A.Group title="Content">
        <A.Input label="Heading" name="heading" />
        <A.Select
          label="Property"
          name="prop"
          noneOption={true}
          options={propOptions}
        />
      </A.Group>
      <A.Group title="Presentation">
        <A.Radio
          label="Text justification"
          name="justification"
          options={A.options({
            left: 'Left justified',
            center: 'Centered',
            right: 'Right justified',
          })}
        />
        <A.Radio
          label="Text position in block"
          name="position"
          options={A.options({
            left: 'Left',
            center: 'Center',
            right: 'Right',
          })}
        />
      </A.Group>
    </>
  )
}
